<template>
  <div class="">
    <el-dialog
      title="查看角色"
      :append-to-body="true"
      :visible.sync="viewDialogVisible"
       :close-on-click-modal="false"
      width="30%"
      :before-close="closeViewDialog">
      <div class="description">
        <el-row :span="24">
          <el-row>
            <el-col :span="4">角色名称：</el-col><el-col :span="8">{{viewData.roleName}}</el-col>
            <el-col :span="4">描述：</el-col><el-col :span="8">{{viewData.remark}}</el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="4">用户总数：</el-col><el-col :span="20">{{viewData.total}}</el-col>
          </el-row> -->
          <el-row>
            <el-col :span="4">创建者：</el-col><el-col :span="8">{{viewData.createUser}}</el-col>
          <el-col :span="4">创建时间：</el-col><el-col :span="8">{{viewData.createTime}}</el-col>
          </el-row>
        </el-row>
      </div>
      <div class="menu">
        <div class="title">已有权限</div>
        <el-tree
        :render-after-expand="false"
          ref="tree"
          :data="permissionList"
          :show-checkbox="false"
          node-key="menuId"
          :props="defaultProps">
          <div class="centerRow" slot-scope="{ node,data }">
            <div class="treeNodeText">
              {{node.label}}
            </div>
            <div  class="childCheck">
              <childCheck
              :disabled="true"
              v-if="data.buttonList && data.buttonList.length > 0"
              :buttonList="data.buttonList"
              :node="node">
              </childCheck>
              <!-- <el-checkbox v-for="(item,index) in data.buttonList" :key="index" v-model="item.buttonValue" :label="item.buttonName" ></el-checkbox> -->
            </div>
          </div>

        </el-tree>
      </div>
      <!-- <el-table
        ref=""
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          prop="createTime"
          label="模块">
        </el-table-column>
        <el-table-column
          label="权限">
        </el-table-column>
      </el-table> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeViewDialog" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getMenuListByRoleId } from '@/api/auth'
import childCheck from '@/components/common/childCheck'
export default {
  components: {
    childCheck
  },
  props: {
    viewDialogVisible: {
      type: Boolean,
      default: false
    },
    viewData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tableData: [],
      permissionList: [],
      defaultProps: {
        children: 'childMenus',
        label: 'menuName'
      }
    }
  },
  created () {
    console.log(this.viewData)
    if (this.viewData) {
      this.getRoleDetail(this.viewData.roleId)
    }
  },
  methods: {
    closeViewDialog () {
      this.$emit('closeViewDialog')
    },
    getRoleDetail (roleId) {
      // 获取指定角色信息
      getMenuListByRoleId(roleId).then(res => {
        res = res.data
        console.log('指定角色信息：', res)
        if (res.data) {
          this.permissionList = res.data
          // const menuId = []
          // this.defaultCheckedKeys = this.getMenuId(res.data.menuVOS)
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.description{
  line-height: 30px;
  .el-col:nth-child(odd){
    text-align: right;
  }
}
.title{
  font-weight: bold;
  margin: 10px 0;
  font-weight: bold;
  font-size: 16px;
}
.menu{
    .centerRow{
      display: flex;
      align-items: middle;
    }
    .childCheck{
      margin-left: 50px;
    }
    .treeNodeText{
        display: flex;
        // align-items: center;
        white-space: nowrap;
    }
    /deep/ .el-tree-node__content{
      height: auto;
      min-height: 26px;
      max-height: 200px;
      align-items: flex-start;
    }
    /deep/ .el-tree-node {
    white-space: normal;
    }
  }
</style>
